import { CalendarPlus } from "lucide-react";

const gcalDate = (d) => d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";

const downloadIcs = (event) => {
  const start = new Date(event.date);
  const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
  const stamp = gcalDate(new Date());
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Amandas Coffee//Events//EN",
    "BEGIN:VEVENT",
    `UID:${event.id}-${stamp}@amandascoffee`,
    `DTSTAMP:${stamp}`,
    `DTSTART:${gcalDate(start)}`,
    `DTEND:${gcalDate(end)}`,
    `SUMMARY:${event.name} — Amanda's Coffee & Retro Video Games`,
    "DESCRIPTION:Call 315-374-8156 with any questions.",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${event.id}.ics`;
  a.click();
  URL.revokeObjectURL(url);
};

export const AddToCalendar = ({ event }) => {
  const hasDate = Boolean(event.date);
  const start = hasDate ? new Date(event.date) : null;
  const end = start ? new Date(start.getTime() + 2 * 60 * 60 * 1000) : null;
  const gcalUrl =
    "https://calendar.google.com/calendar/render?action=TEMPLATE" +
    `&text=${encodeURIComponent(`${event.name} — Amanda's Coffee & Retro Video Games`)}` +
    (start ? `&dates=${gcalDate(start)}/${gcalDate(end)}` : "") +
    `&details=${encodeURIComponent("Call 315-374-8156 with any questions.")}`;

  return (
    <div className="flex items-center justify-center gap-2 mt-3">
      <a
        data-testid={`gcal-${event.id}`}
        href={gcalUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#FF2E88] text-white text-[10px] font-bold uppercase mono-lbl hover:bg-[#D61F73] transition-colors"
      >
        <CalendarPlus className="w-3.5 h-3.5" />
        Google
      </a>
      {hasDate && (
        <button
          data-testid={`ics-${event.id}`}
          onClick={() => downloadIcs(event)}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#26153F] border border-[#3B2760] text-[#2DE2E6] text-[10px] font-bold uppercase mono-lbl hover:bg-[#3B2760] transition-colors"
        >
          <CalendarPlus className="w-3.5 h-3.5" />
          Phone / .ics
        </button>
      )}
    </div>
  );
};
